var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from 'react';
import { PageTitle } from '@src/_metronic/layout/core';
import { KTCard, KTSVG } from '@src/_metronic/helpers';
import DataTable from 'react-data-table-component';
import { MenuComponent } from '@src/_metronic/assets/ts/components';
import { useIntl } from 'react-intl';
import { Link, useNavigate } from 'react-router-dom';
import { FormatDateTime, paginationOptions, MultiDimensionalFilter, RoleList, userInformation, FormatYearMonth, } from '@src/app/helper';
import Input from '@src/components/Atoms/Input/Input';
import { useSaldoTeams } from '../SaldoTeamHooks/SaldoTeam.hooks';
import NotFound from '@src/components/Atoms/NotFound/NotFound';
import Loading from '@src/components/Atoms/Loading/Loading';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useTeams } from '../../TeamPage/TeamHooks/Team.hooks';
import Select from '@src/components/Atoms/Select/Select';
//breadcrumb
var usersBreadcrumbs = [
    {
        title: 'SaldoTeam',
        path: '',
        isSeparator: true,
        isActive: false,
    },
];
var SaldoTeamIndex = function () {
    var role = JSON.parse(userInformation).roles[0];
    var teams = JSON.parse(userInformation).teams;
    var _a = useState(''), selectedTeam = _a[0], setSelectedTeam = _a[1];
    var navigate = useNavigate();
    var intl = useIntl();
    var _b = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
    }), filterSearch = _b[0], setFilterSearch = _b[1];
    var _c = useTeams(filterSearch), team = _c.team, refetchTeam = _c.refetch;
    //initialize filter
    var _d = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: "[]",
    }), filter = _d[0], setFilter = _d[1];
    //getdata
    var _e = useSaldoTeams(filter), saldoTeams = _e.saldoTeams, isLoading = _e.isLoading;
    var saldoTeamsData = saldoTeams === null || saldoTeams === void 0 ? void 0 : saldoTeams.data.dealings;
    //pagination
    var handlePageChange = function (page) {
        setFilter(__assign(__assign({}, filter), { page: page }));
    };
    var handlePageSizeChange = function (size) {
        setFilter(__assign(__assign({}, filter), { page: 1, pageSize: size }));
    };
    var optionTeam = role == RoleList.CampaignExecutive ? teams &&
        teams.map(function (team) { return ({
            name: team.name,
            value: team.pubId,
        }); }) :
        team && team.data && team.data.map(function (team) { return ({
            name: team.name,
            value: team.pubId,
        }); });
    //search & filters
    var handleMultiDimensionalFilterChange = function (event) {
        var filterValue = filter.filterBy !== '' ? JSON.parse(filter.filterBy) : '';
        if (filter.filterBy === '') {
            var filterCriteria = [[event.target.name, event.target.value]];
            setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterCriteria) }));
        }
        else {
            var filterNew = MultiDimensionalFilter(event, filterValue);
            setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterNew) }));
        }
    };
    var handleFilterChange = function (event) {
        var _a;
        setFilter(__assign(__assign({}, filter), (_a = {}, _a[event.target.name] = event.target.value, _a)));
    };
    var _f = useState(Number(dayjs)), monthYear = _f[0], setMonthYear = _f[1];
    var onChangeDate = function (e) {
        var event = { target: { name: '', value: null } };
        event.target.name = 'date';
        event.target.value = e == null ? '' : FormatYearMonth(e).split('/').join('-');
        setMonthYear(e);
        handleMultiDimensionalFilterChange(event);
    };
    useEffect(function () {
        MenuComponent.reinitialization();
    }, []);
    useEffect(function () {
        var filterValue = JSON.parse(filter.filterBy);
        if (teams && teams.length > 0) {
            var filterCriteria = ['team.pubId', optionTeam && optionTeam[0].value];
            filterValue.push(filterCriteria);
        }
        setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify(filterValue) }));
    }, []);
    var columns = [
        {
            name: 'No Kerjasama',
            cell: function (record) {
                return (_jsxs("div", { children: [record.job ? (_jsx("a", __assign({ href: "/job/detail/".concat(record.job.jobNumber), onClick: function () { return navigate("/job/detail/".concat(record.job.jobNumber)); } }, { children: record.job.jobNumber }))) : ('-'), record.talent ? _jsx("p", { children: record.talent.name }) : ''] }));
            },
            sortable: true,
        },
        {
            name: 'Amount',
            cell: function (record) {
                return (_jsxs("div", { children: [record.debit > 0 ? _jsxs("p", { children: ["Rp ", record.debit.toLocaleString()] }) : '', record.credit > 0 ? _jsxs("p", { children: [" Rp -", record.credit.toLocaleString()] }) : ''] }));
            },
            sortable: true,
        },
        {
            name: 'Tanggal',
            cell: function (row) { return FormatDateTime(row.date); },
            sortable: true,
        },
    ];
    return (_jsxs(Fragment, { children: [_jsx(PageTitle, __assign({ breadcrumbs: usersBreadcrumbs }, { children: "SaldoTeams" })), _jsxs(KTCard, { children: [_jsx("div", __assign({ className: 'd-flex flex-column' }, { children: _jsxs("div", __assign({ className: 'card-header border-0 pt-6 d-flex flex-row' }, { children: [_jsxs("div", __assign({ className: 'card-title flex' }, { children: [_jsx("div", __assign({ className: 'mb-5 px-1 d-flex flex-column flex-row-auto' }, { children: _jsx(Input, { placeholder: 'Search', type: 'text', name: 'keyword', value: filter.keyword, onChange: function (e) {
                                                    handleFilterChange(e);
                                                } }) })), _jsx("div", __assign({ className: 'mb-5 px-1 d-flex flex-column flex-row-auto' }, { children: _jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: _jsx(DatePicker, { views: ['month', 'year'], value: monthYear, inputFormat: 'MM/YYYY', onChange: function (newValue) {
                                                        onChangeDate(newValue);
                                                    }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } }) })) })), _jsx("div", __assign({ className: 'mb-5 px-1 d-flex flex-column flex-row-auto' }, { children: optionTeam && optionTeam.length > 0 && (_jsx(Select, { name: 'team.pubId', onChange: function (e) {
                                                    handleMultiDimensionalFilterChange(e);
                                                }, placeholder: 'Filter by Teams', optionList: optionTeam, defaultValue: teams && teams.length > 0 && optionTeam[0].value })) }))] })), role == RoleList.SpvCampaignExecutive && (_jsx("div", __assign({ className: 'card-toolbar justify-content-end' }, { children: _jsx("div", __assign({ className: 'd-flex justify-content-end', "data-kt-bank-table-toolbar": 'base' }, { children: _jsx("div", __assign({ className: 'me-3' }, { children: _jsx(Link, __assign({ to: 'add' }, { children: _jsxs("button", __assign({ type: 'button', className: 'btn btn-primary' }, { children: [_jsx(KTSVG, { path: '/media/icons/duotune/arrows/arr075.svg', className: 'svg-icon-2' }), "Tambah"] })) })) })) })) })))] })) })), _jsx("div", __assign({ className: 'card-body py-4' }, { children: _jsx(DataTable, { title: ' ', columns: columns, persistTableHead: true, noDataComponent: _jsx(NotFound, {}), data: saldoTeamsData ? saldoTeamsData : [], noHeader: true, progressPending: isLoading, progressComponent: _jsx(Loading, {}), pagination: true, paginationServer: true, paginationDefaultPage: filter.page, paginationTotalRows: saldoTeams && saldoTeams.recordsFiltered, paginationPerPage: filter.pageSize, paginationRowsPerPageOptions: [1, 10, 20, 30, 40, 50, 100], paginationComponentOptions: paginationOptions, onChangeRowsPerPage: handlePageSizeChange, onChangePage: handlePageChange }) }))] }), _jsx("div", __assign({ className: "card px-5 py-5 mt-5" }, { children: _jsxs("div", __assign({ className: 'd-flex flex-row flex-column-fluid' }, { children: [_jsx("div", __assign({ className: 'd-flex flex-row-fluid flex-start' }, { children: _jsx("h6", __assign({ className: '' }, { children: "Total Pengeluaran" })) })), _jsx("div", __assign({ className: 'd-flex flex-row-fluid flex-end' }, { children: _jsxs("h6", __assign({ className: '' }, { children: ["Rp ", saldoTeams === null || saldoTeams === void 0 ? void 0 : saldoTeams.data.total.toLocaleString()] })) }))] })) }))] }));
};
export default SaldoTeamIndex;
